import axios from 'axios';
import { API_URL } from '../utils/constants';

export function appForPath(pathname, catalog) {
  return Object.entries(catalog)
    .sort((a, b) => b[1].link.length - a[1].link.length)
    .find(([, app]) => pathname === app.link || pathname.startsWith(`${app.link}/`))?.[0];
}

// Independent transport: an optional usage failure must never log out a user,
// mark the application offline, or prevent a business operation.
export async function recordToolOpening(app, navigationId, userId = '') {
  if (!app) return;
  try {
    let visitorId = localStorage.getItem('tool_usage_visitor');
    if (!visitorId) {
      visitorId = window.crypto.randomUUID();
      localStorage.setItem('tool_usage_visitor', visitorId);
    }
    const key = `tool_usage_open:${app}:${navigationId}:${userId}`;
    const stored = sessionStorage.getItem(key);
    const eventId = stored || window.crypto.randomUUID();
    // Keep the same event id across StrictMode and retries. Only UUIDs are sent.
    if (stored?.startsWith('sent:')) return;
    sessionStorage.setItem(key, eventId);
    const token = localStorage.getItem('token');
    await axios.post(`${API_URL}/tool-usage/events`, { app, action: 'opened', eventId, visitorId }, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}, timeout: 5000,
    });
    sessionStorage.setItem(key, `sent:${eventId}`);
  } catch { /* Usage collection is optional; useful actions are recorded by the server. */ }
}
